export const GOBACK_COOKIE = 'gobackurl'
export const GOBACK_MAX_AGE = 600

// same-app absolute path (already includes appconfig.pathPrefix), no scheme, no protocol-relative
export const isValidReturnPath = (v) =>
  typeof v === 'string' && v.length < 512 && v.startsWith('/') && !v.startsWith('//') && !v.includes('://')

export const getReturnPath = (cookies) =>
  isValidReturnPath(cookies[GOBACK_COOKIE]) ? cookies[GOBACK_COOKIE] : null

// shared resolution: router state.from (full prefixed path incl. search) → cookie
export const resolveReturnPath = (state, cookies) => {
  let p = null
  if (state && state.from) {
    p = (state.from.pathname || state.from) + (state.from.search || '')
  } else if (getReturnPath(cookies)) {
    p = getReturnPath(cookies)
  }
  return isValidReturnPath(p) ? p : null
}

export const setReturnPathCookie = (setCookie, path) =>
  setCookie(GOBACK_COOKIE, path, {
    path: '/',
    maxAge: GOBACK_MAX_AGE,
    // a hardcoded Secure attribute would silently drop the cookie on plain-HTTP origins
    secure: window.location.protocol === 'https:',
    sameSite: 'lax',
  })
